import { render, staticRenderFns } from "./document-result.vue?vue&type=template&id=49ad3e5f&"
import script from "./document-result.vue?vue&type=script&lang=js&"
export * from "./document-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports